<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
    :hot-key-grid-tab-index="2"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Product"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.ProductCode"
        :secondaryLabel="model.ProductDescription1"
        recordType="Product"
        v-if="model.ProductCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="productCostGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @content-ready="addGridNoResults($event)"
                  v-if="model.ProductCode"
                  :selection="{ mode: 'single' }"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Product - ${baseView.id} - Costs`,
                      columns
                    )
                  "
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager
                    :showInfo="true"
                    :showPageSizeSelector="false"
                    :infoText="'({2} items)'"
                    :visible="false"
                  />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #branch-cell-template="{ data }">
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.BranchDescription"
                      :code="data.data.BranchCode"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.ProductCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar" v-if="loadingCompleted">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary">{{ model.BranchDescription }}</span>
                <span class="text-secondary ml-sm">{{ model.BranchCode }}</span>
              </div>
            </DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarForm-2',
                labelLocation: 'left',
                customizeItem: customizeItem,
              }"
              locate-in-menu="auto"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />

            <!-- <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />-->

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings" v-if="loadingCompleted">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import {
  ProductTabs,
  ProductTabsVisibility,
} from "../../_models/tabdata/products/products-tabs";
import { ProductCostService } from "../../_services/api/products/product-cost.service";
import { ProductService } from "../../_services/api/products/product.service";

export default {
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 2;
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          onClick: this.close,
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/product-cost/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveProductCost(e);
          },
        },
        //  delete: {
        //     icon: "trash",
        //     validationGroup: "formsData",
        //     onClick: e => {
        // this.$logger.trackEventButtonClickDelete();
        //       this.deleteProductCost(e);
        //     }
        //   },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        BranchCode: "",
      },
      model: {
        ProductCode: "",
        ProductDescription1: "",
        BranchCode: "",
        BranchDescription: "",
        RecordId: "00000000-0000-0000-0000-000000000000",
        AllBranches: true,
        StandardCost: 0,
        Rop: 0,
        Roq: 0,
        MinStockQty: 0,
        MaxStockQty: 0,
        StandardSell: 0,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        StockItem: undefined,
        AvailableForSale: undefined,

        MaterialResource: 0,
        LabourResource: 0,
        FBurden: 0,
        OutsideResource: 0,
        ManufacturedCost: 0,
        Burden1: 0,
        Burden2: 0,
        FullCost: 0,
      },
    };
  },
  computed: {
    toolbarActiveItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "AllBranches",
              gcType: "Boolean",
              gcLabel: "Update All Branches",
            },
          ]),
        },
      ];
    },
    initialFilter() {
      return [["ProductCode", "=", this.model.ProductCode]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "BranchCode",
              gcLabel: "Branch",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig("api/Branch", {
                  select: ["Code", "Description"],
                  sort: [{ selector: "Code", asc: true }],
                  top: 5,
                  filter: ["Inactive", "=", "N"],
                  key: "Code",
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                itemTemplate: "item-template",
                searchEnabled: true,
              },
            },
          ]),
        },
      ];
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              gcLabel: "Material",
              gcType: "Decimal-4-4",
              dataField: "MaterialResource",
              visible: this.model.Source == "M",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
            },
            {
              gcLabel: "Labour",
              gcType: "Decimal-4-4",
              dataField: "LabourResource",
              visible: this.model.Source == "M",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
            },
            {
              gcLabel: "Factory Overhead",
              gcType: "Decimal-4-4",
              dataField: "FBurden",
              visible: this.model.Source == "M",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
            },
            {
              gcLabel: "Manufacturing Overhead",
              gcType: "Decimal-4-4",
              dataField: "OutsideResource",
              visible: this.model.Source == "M",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
            },
            {
              gcLabel: "Manufactured Cost",
              gcType: "Decimal-4-4",
              dataField: "ManufacturedCost",
              visible: this.model.Source == "M",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
            },
            {
              gcLabel: "Sale Overhead",
              gcType: "Decimal-4-4",
              dataField: "Burden1",
              visible: this.model.Source == "M",
              editorOptions: {
                // readOnly: true,
                onValueChanged: () => {
                  this.updateFullCost();
                },
              },
            },
            {
              gcLabel: "Admin Overhead",
              gcType: "Decimal-4-4",
              dataField: "Burden2",
              visible: this.model.Source == "M",
              editorOptions: {
                // readOnly: true,
                onValueChanged: () => {
                  this.updateFullCost();
                },
              },
            },
            {
              gcLabel: "Full Cost",
              gcType: "Decimal-4-4",
              dataField: "FullCost",
              visible: this.model.Source == "M",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
            },

            {
              dataField: "StandardCost",
              gcType: "Decimal-4-4",
              gcLabel: "Standard Cost",
              editorOptions: {
                min: 0,
                max: 999999999.99,
              },
              visible:
                this.model.StockItem !== "N" ||
                this.model.AvailableForSale !== "N",
              validationRules: [
                {
                  type: "required",
                  message: "Std Cost is required",
                },
                {
                  type: "range",
                  message:
                    "Standard Cost must be between 0 and 999,999,999.9999",
                  min: 0.0000,
                  max: 999999999.9999,
                },
              ],
            },
            {
              dataField: "StandardCost",
              gcType: "Decimal-4-4",
              gcLabel: "Standard Cost",
              visible:
                this.model.StockItem == "N" &&
                this.model.AvailableForSale == "N",
              validationRules: [
                {
                  type: "required",
                  message: "Std Cost is required",
                },
              ],
            },
            {
              dataField: "Rop",
              gcType: "Decimal-4-4",
              gcLabel: "Reorder Point",
              validationRules: [
                {
                  type: "required",
                  message: "Reorder Point is required",
                },
                {
                  type: "range",
                  message:
                    "Reorder Point must be between 0.0001 and 999,999,999.9999",
                  min: 0.0,
                  max: 999999999.9999,
                },
              ],
            },

            {
              dataField: "Roq",
              gcType: "Decimal-4-4",
              gcLabel: "Reorder Qty",
              validationRules: [
                {
                  type: "required",
                  message: "Reorder Point is required",
                },
                {
                  type: "range",
                  message:
                    "Reorder Qty must be between 0.0001 and 999,999,999.00",
                  min: 0.0,
                  max: 999999999.0,
                },
              ],
            },

            {
              dataField: "MinStockQty",
              gcType: "Decimal-4-2",
              gcLabel: "Min Stock Qty",
              validationRules: [
                {
                  type: "range",
                  message: "Min Stock Qty must be between 0 and 999,999,999.00",
                  min: 0.0,
                  max: 999999999.0,
                },
              ],
            },

            {
              dataField: "MaxStockQty",
              gcType: "Decimal-4-2",
              gcLabel: "Max Stock Qty",
              validationRules: [
                {
                  type: "range",
                  message: "Max Stock Qty must be between 0 and 999,999,999.00",
                  min: 0.0,
                  max: 999999999.0,
                },
              ],
            },
          ]),
        },
      ];

      return formFields;
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Branch",
          dataField: "BranchDescription",
          cellTemplate: "branch-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["BranchCode", "BranchDescription"],
        },
        {
          gcLabel: "Manufactured Cost",
          dataField: "ManufacturedCost",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Full Cost",
          dataField: "FullCost",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Standard Cost",
          dataField: "StandardCost",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Last Cost",
          dataField: "LastUnitCost",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Ave Cost",
          dataField: "AverageUnitCost",
          gcType: "Decimal-4-4",
        },

        {
          gcLabel: "Reorder Point",
          dataField: "Rop",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Reorder Qty",
          dataField: "Roq",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Min Stock Qty",
          dataField: "MinStockQty",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Max Stock Qty",
          dataField: "MaxStockQty",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Branch Description",
          dataField: "BranchDescription",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
    dataSourceConfig() {
      // eslint-disable-next-line no-debugger

      return ProductCostService.dataSourceConfig("api/ProductCostList", {
        select: [
          "ProductCode,BranchDescription,BranchCode,StandardCost,Rop,Roq,MinStockQty,MaxStockQty,RecordId,StandardSell",
          "LastUnitCost",
          "AverageUnitCost",
          "ManufacturedCost",
          "FullCost",
        ],
        // sort: [{ selector: "ProductCode", desc: false }],
        filter: [["ProductCode", "=", this.model.ProductCode]],
      });
    },
    tabs() {
      if (this.loadingCompleted)
        return ProductTabs(
          this.model.ProductCode ? this.model.ProductCode : this.baseView.id
        );
      else return [];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["productCostGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    updateFullCost() {
      this.model.FullCost =
        this.model.ManufacturedCost + this.model.Burden1 + this.model.Burden2;
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    async close() {
      if (this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["productCostGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.ProductCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-cost/review/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["productCostGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.ProductCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/product-cost/review/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/product",
      });
    },

    async handleLocalRouteChange() {
      this.loadingCompleted = false;
      let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.model.RecordId = this.baseView.id;
        await this.getRecord().then(async (response) => {
          if (response.data.value.length > 0) {
            that.model.DateChanged = response.data.value[0].DateChanged;
            that.model.DateCreated = response.data.value[0].DateCreated;
            that.model.ChangedBy = response.data.value[0].ChangedBy;
            that.model.CreatedBy = response.data.value[0].CreatedBy;
            that.model.RecordId = response.data.value[0].RecordId;

            that.model.ProductCode = response.data.value[0].Product.Code;
            that.model.ProductDescription1 =
              response.data.value[0].Product.Description1;
            that.model.Source = response.data.value[0].Product.Source;

            that.model.StandardCost = response.data.value[0].StandardCost;
            that.model.Rop = response.data.value[0].Rop;
            that.model.Roq = response.data.value[0].Roq;
            that.model.MinStockQty = response.data.value[0].MinStockQty;
            that.model.MaxStockQty = response.data.value[0].MaxStockQty;
            that.model.BranchCode = response.data.value[0].BranchCode;
            that.model.BranchDescription =
              response.data.value[0].Branch.Description;

            that.model.MaterialResource =
              response.data.value[0].MaterialResource;
            that.model.LabourResource = response.data.value[0].LabourResource;
            that.model.FBurden = response.data.value[0].FBurden;
            that.model.OutsideResource = response.data.value[0].OutsideResource;
            that.model.ManufacturedCost =
              response.data.value[0].ManufacturedCost;
            that.model.Burden1 = response.data.value[0].Burden1;
            that.model.Burden2 = response.data.value[0].Burden2;
            that.model.FullCost = response.data.value[0].FullCost;

            if (response.data.value[0].Product) {
              that.model.StockItem = response.data.value[0].Product.StockItem;
              that.model.AvailableForSale =
                response.data.value[0].Product.AvailableForSale;
              ProductTabsVisibility({
                text: "Kit Components",
                value:
                  response.data.value[0].Product.IsKit == "Y" ? true : false,
              });
            }

            // that.refreshView();
          }

          this.loadingCompleted = true;
        });
      } else {
        if (!that.model.ProductCode) {
          await ProductService.getByCode(that.baseView.id).then((response2) => {
            if (response2.data.value.length > 0) {
              that.model.StockItem = response2.data.value[0].StockItem;
              that.model.AvailableForSale =
                response2.data.value[0].AvailableForSale;
              that.model.ProductCode = response2.data.value[0].Code;
              that.model.ProductDescription1 =
                response2.data.value[0].Description1;
              that.model.UnitOfMeasureCode =
                response2.data.value[0].UnitOfMeasureCode;
              // that.refreshView();
              ProductTabsVisibility({
                text: "Kit Components",
                value: response2.data.value[0].IsKit == "Y" ? true : false,
              });
            }
            this.loadingCompleted = true;
          });
        } else {
          // if (this.showRightContainer)
          this.loadingCompleted = true;
        }
      }
    },

    async getRecord() {
      return ProductCostService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/product-cost/review/${selectedRowsData[0].RecordId}`,
      });
    },

    async saveProductCost(e) {
      const result = await e.validationGroup.validate();
      // eslint-disable-next-line no-console
      // this.$logger.debug("Model", this.model);
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);

      var that = this;
      await ProductCostService.save(this.baseView.mode, {
        ProductCode: this.model.ProductCode,
        StandardCost: this.model.StandardCost,
        Rop: this.model.Rop,
        Roq: this.model.Roq,
        MinStockQty: this.model.MinStockQty,
        MaxStockQty: this.model.MaxStockQty,
        AllBranches: this.model.AllBranches ? "Y" : "N",
        RecordId: this.model.RecordId,

        MaterialResource: this.model.MaterialResource,
        LabourResource: this.model.LabourResource,
        FBurden: this.model.FBurden,
        OutsideResource: this.model.OutsideResource,
        ManufacturedCost: this.model.ManufacturedCost,
        Burden1: this.model.Burden1,
        Burden2: this.model.Burden2,
        FullCost: this.model.FullCost,
      })
        .then((res) => {
          if (this.baseView.mode == "edit") {
            this.model.RecordId = res.data.RecordId;
            this.model.ProductCode = res.data.ProductCode;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveProductCost", res);

          var msg = this.model.AllBranches
            ? "all branches"
            : `branch ${this.model.BranchDescription}`;

          this.$notify(`Product cost for ${msg} saved successfully`, "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-cost/review/${that.baseView.id}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Product cost save failed");
        });
    },
  },
};
</script>
